$(document).ready(function () {
  $(".testimonials ").slick({
      slidesToShow: 3,
      infinite: false,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      responsive: [
          {
              breakpoint: 1200,
              settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
              },
          },
          {
              breakpoint: 800,
              settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
              },
          },
      ],
  });


$('.responsive1').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
				


$('.responsive').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 5,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
});

//product scroll
$(document).ready(function () {
  var step = 500;
  var scrolling = true;
  $(".probtn.prev").bind("click", function (event) {
      event.preventDefault();
      $("div").animate({
          scrollLeft: "-=" + step + "px",
      });
  });

  $(".probtn.next").bind("click", function (event) {
      event.preventDefault();
      $("div").animate({
          scrollLeft: "+=" + step + "px",
      });
  });
});
//product scroll

$(document).ready(function() {
  $drawerRight = $('.deliver-drawer-right');
  $cart_list = $('.deliver-drawer-btn, .deliver-drawer-close-btn');
    
  $cart_list.click(function() {
    $(this).toggleClass('active');
    $('p').toggleClass('deliver-drawer-pushtoleft');
    $drawerRight.toggleClass('deliver-drawer-open');
  });
});

$(document).ready(function() {
  $drawerRightTwo = $('.deliver-drawer-right-two');
  $cart_list_two = $('.deliver-drawer-btn-two, .deliver-drawer-close-btn-two');
    
  $cart_list_two.click(function() {
    $(this).toggleClass('active');
    $('p').toggleClass('deliver-drawer-pushtoleft');
    $drawerRightTwo.toggleClass('deliver-drawer-open-two');
  });
});

$(document).ready(function() {
    $drawerRightThree = $('.deliver-drawer-right-three');
	$cart_list_three = $('.deliver-drawer-btn-three, .deliver-drawer-close-btn-three');
  
	$cart_list_three.click(function() {
		$(this).toggleClass('active');
		$('p').toggleClass('deliver-drawer-pushtoleft');
		$drawerRightThree.toggleClass('deliver-drawer-open-three');
	});
});


  const selectHotspot = (e) => {
  const clickedHotspot = e.target.parentElement;
  const container = clickedHotspot.parentElement;
  
  // only include hotspots within same image to allow one open hotspot per image; change "container" to "document" to allow only one open hotspot for entire page:
  const hotspots = container.querySelectorAll(".lg-hotspot"); 
  hotspots.forEach(hotspot => {
    if (hotspot === clickedHotspot) {
      hotspot.classList.toggle("lg-hotspot--selected");
    } else {
      hotspot.classList.remove("lg-hotspot--selected");
    }
  });
}

(() => {
  const buttons = document.querySelectorAll(".lg-hotspot__button");
  buttons.forEach(button => {
    button.addEventListener("click", selectHotspot);
  });
})();

document.addEventListener("DOMContentLoaded", function() {
  var lazyloadImages = document.querySelectorAll("img.lazy");    
  var lazyloadThrottleTimeout;
  
  function lazyload () {
    if(lazyloadThrottleTimeout) {
      clearTimeout(lazyloadThrottleTimeout);
    }    
    
    lazyloadThrottleTimeout = setTimeout(function() {
        var scrollTop = window.pageYOffset;
        lazyloadImages.forEach(function(img) {
            if(img.offsetTop < (window.innerHeight + scrollTop)) {
              img.src = img.dataset.src;
              img.classList.remove('lazy');
            }
        });
        if(lazyloadImages.length == 0) { 
          document.removeEventListener("scroll", lazyload);
          window.removeEventListener("resize", lazyload);
          window.removeEventListener("orientationChange", lazyload);
        }
    }, 20);
  }
  
  document.addEventListener("scroll", lazyload);
  window.addEventListener("resize", lazyload);
  window.addEventListener("orientationChange", lazyload);
});
